<template>
  <div class="login-page" v-on:keyup.enter=login>
    <vue-particles
      style="position: absolute;top: 0;bottom: 0;left: 0;right: 0"
      color="#fff"
      :particleOpacity="0.7"
      :particlesNumber="100"
      shapeType="circle"
      :particleSize="4"
      linesColor="#fff"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="3"
      :hoverEffect="true"
      hoverMode="grab"
      :clickEffect="true"
      clickMode="push"
      class="lizi"/>
    <a-row :gutter="10" style="margin-top: 25vh">
      <a-col :md="{span:6,offset:9}" :sm="{span:12,offset:6}" :xs="{span:24,offset:0}">
        <div class="login-form-wrap">
          <div style="margin-bottom: 30px">
            <div style="margin-bottom: 20px">
              <img style="width: 150px;" src="../../assets/logo-rexel.png">
            </div>
            <div style="font-size: 24px">蓝格赛智慧物流（履约宝）平台</div>
          </div>
          <a-form-model
            ref="form"
            :model="form.data" :rules="form.rule" v-on:keyup.enter=login
          >
            <a-form-model-item :title="$t('LOGIN_NAME')||'账号'" prop="loginName">
              <a-input
                size="large"
                v-model="form.data.loginName"
                :disabled="form.disabled"
              >
                <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)"/>
              </a-input>
            </a-form-model-item>
            <a-form-model-item :title="$t('PASSWORD')||'密码'" prop="password">
              <a-input-password
                size="large"
                v-on:keyup.enter=login
                v-model="form.data.password"
                :disabled="form.disabled"
                show-password>
                <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)"/>
              </a-input-password>
            </a-form-model-item>
            <a-form-model-item>
              <a-button
                size="large"
                block
                @click="login" v-on:keyup.enter=login :disabled="form.disabled">
                {{ $t('LOGIN') || '登录' }}
                <i class="el-icon-arrow-right el-icon--right" v-if="!form.disabled"/>
                <i class="el-icon-loading el-icon--right" v-if="form.disabled"/>
              </a-button>
              <!--              <language-switch style="float: right"/>-->
            </a-form-model-item>
          </a-form-model>
          <div style="font-size: 16px">30分钟内无操作，系统自动退出</div>
          <div style="font-size: 15px ;margin-top: 20px;">沪ICP备12024648号-1</div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {
  _login,
} from '@/api/sys/loginApi';
import CryptoJS from 'crypto-js';
import LanguageSwitch from '@/components/LanguageSwitch.vue';

async function login() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      this.form.disabled = true;
      const result = await _login({
        loginName: this.form.data.loginName,
        password: CryptoJS.MD5(this.form.data.password).toString().toUpperCase(),
      });
      if (result && result) {
        this.$store.commit('setLoginInfo', {
          userName: result.loginName,
          token: result.token,
        });
        localStorage.setItem('roles', JSON.stringify(result.roles));
        const menusList = result.menus || [];
        const menus = menusList.filter(menu => menu.type === 'MENU')
          .sort((a, b) => a.sort.localeCompare(b.sort));
        localStorage.setItem('MENUS', JSON.stringify(menus));
        const BUTTON = menusList.filter(menu => menu.type === 'BUTTON')
          .map(x => x.code);
        localStorage.setItem('BUTTONS', JSON.stringify(BUTTON));
        await this.$router.push('/');
        return;
      }
      this.$message.error('登录异常，请重新登录');
      this.form.disabled = false;
    }
  });
}


export default {
  name: 'Login',
  components: { LanguageSwitch },
  async created() {
  },
  methods: {
    login,
  },
  mounted() {
  },
  data() {
    return {
      autoLogin: false,
      form: {
        disabled: false,
        data: {
          loginName: null,
          password: null,
        },
        rule: {
          loginName: [{
            required: true,
            message: '请输入账号',
            trigger: 'blur',
          }],
          password: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          }],
        },
      },
    };
  },
};
</script>

<style>
.login-page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f0f2f5;
  overflow: hidden;
  background-image: url("../../assets/background.png");
  background-repeat: no-repeat;
  background-origin: content-box;
  background-size: cover;
}

.login-page .a-form-model-item__label {
  color: #ffffff;
}


.login-form-wrap {
  border-radius: 5px;
  /*background: #ffffff24;*/
  padding: 40px;
  background: #ffffff8f;
  box-shadow: #ffffffbf 0px 0px 8px 5px;
}

.canvas {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffff;
  /*background-image: linear-gradient(122deg, #000000 0%, #52383d 27%, #ffffff 100%);*/

}
</style>
